import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.182 4a6.182 6.182 0 0 1 6.182 6.182V12.5L12.182 21 6 12.5v-2.318A6.182 6.182 0 0 1 12.182 4zm0 2.903a3.278 3.278 0 1 0 0 6.557 3.278 3.278 0 0 0 0-6.557z",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }